import { FileX } from 'lucide-react';

export const EmptyState = ({ title = 'Sin datos', description = 'No hay información disponible.', icon: Icon = FileX }) => (
  <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="empty-state">
    <div className="h-16 w-16 rounded-2xl bg-slate-50 flex items-center justify-center mb-5">
      <Icon className="h-7 w-7 text-slate-300" strokeWidth={1.5} />
    </div>
    <h3 className="text-sm font-semibold text-slate-600 mb-1">{title}</h3>
    <p className="text-[12px] text-slate-400 max-w-[260px] leading-relaxed">{description}</p>
  </div>
);
